import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

const DiscoveryPage = () => {
  return <MainMenuComponent menuName='Discovery' />;
};

export default DiscoveryPage;
